/*
 * Filename: form-control-configuration-panel.component.tsx
 * Description: Page section holds fields level configuration information
 */

import React, { Component, ReactNode } from 'react';
import { observer } from 'mobx-react';
import { StandardHeaderActionComponentRootComponent } from './grid-config-tab/grid-right-pane/header-standard-actions.component';
import { CustomHeaderActionComponentRootComponent } from './grid-config-tab/grid-right-pane/header-custom-actions.component';
import { CQMasterDataStore } from '../../../store/cq-master-data.store';
import { StandardRowActionComponentRootComponent } from './grid-config-tab/grid-right-pane/row-standard-actions.component';
import { CustomRowActionComponentRootComponent } from './grid-config-tab/grid-right-pane/row-custom-actions.component';
import { AddedCustomHeaderActionRootComponent } from './grid-config-tab/grid-right-pane/added-header-custom-action.component';
import { AddedCustomRowActionRootComponent } from './grid-config-tab/grid-right-pane/added-row-custom-action.component';
import { GridCustomComponent } from './grid-config-tab/grid-right-pane/add-field-to-custom-component';
import { CQFormControlConfigurationRootComponent } from '../layout-configuration-panel/form-control-configuration-root.component';
export class CQGridControlConfiguration
    extends Component<{ selectedTemplateName: string, selectedCustomComponent: any }, { isBulkChecked: boolean, isApplyRuleModalVisisble: boolean, lwcComponentList: any[], selectedComponentName: string, name: string, label: string }> {

    constructor(props: Readonly<{ selectedTemplateName: string, isLayoutApplicable: boolean, selectedCustomComponent: any }>) {
        super(props);
    }

    componentDidMount() {
        const outputConfig = CQMasterDataStore.OutputConfig;
        let ruleElementsObj: any = outputConfig.getStoreKeyData(this.props.selectedTemplateName, 'ruleElements');
        //let ruleElementsObj = { ...CQMasterDataStore.RuleElements.FieldRuleElement };
        if (ruleElementsObj.hasOwnProperty('gridObj')) {
            let gridObj = { ...ruleElementsObj.gridObject };
            Object.keys(gridObj).length && Object.keys(gridObj).map((actionObjectKey: any) => {
                if (!gridObj[actionObjectKey].hasOwnProperty('isActionSaved')) {
                    delete gridObj[actionObjectKey];
                }
            });
            ruleElementsObj.gridObject = gridObj;
            CQMasterDataStore.OutputConfig.updateTemplatePropertyValue(this.props.selectedTemplateName, 'ruleElements', ruleElementsObj);
            // CQMasterDataStore.RuleElements.addGridObject(ruleElementsObj);
        }
    }

    public render(): ReactNode {
        const selectedAction = CQMasterDataStore.GridObject.selectedAction;
        return (
            <>
                {
                    !selectedAction ? <div className="slds-col config-sidebar full-height">
                        <div className="bg-white full-height scroll-content slds-p-around_small">
                            <div>
                                Please select action
                        </div>
                        </div>
                    </div> : this.loadView()
                }
            </>
        );
    }

    private loadView = () => {
        const selectedAction = CQMasterDataStore.GridObject.selectedAction;
        const selectedHeaderAction = CQMasterDataStore.GridObject.selectedHeaderAction;
        const selectedRowAction = CQMasterDataStore.GridObject.selectedRowAction
        switch (selectedAction) {
            case 'standardHeaderAction':
                return <StandardHeaderActionComponentRootComponent action={selectedHeaderAction}
                    selectedTemplateName={this.props.selectedTemplateName} />
                break;
            case 'customHeaderAction':
                return <CustomHeaderActionComponentRootComponent action={selectedHeaderAction}
                    selectedTemplateName={this.props.selectedTemplateName} />
                break;
            case 'addedCustomHeaderAction':
                return <AddedCustomHeaderActionRootComponent action={selectedHeaderAction}
                    selectedTemplateName={this.props.selectedTemplateName} />
                break;
            case 'standardRowAction':
                return <StandardRowActionComponentRootComponent action={selectedRowAction}
                    selectedTemplateName={this.props.selectedTemplateName} />
                break;
            case 'gridComponentLayout':
                return <CQFormControlConfigurationRootComponent selectedTemplateName={this.props.selectedTemplateName} />
                break;
            case 'customRowAction':
                return <CustomRowActionComponentRootComponent action={selectedRowAction}
                    selectedTemplateName={this.props.selectedTemplateName} />
                break;

                case 'customComponent':
                    return <GridCustomComponent selectedTemplateName={this.props.selectedTemplateName} selectedCustomComponent= {this.props.selectedCustomComponent} />

            case 'addedCustomRowAction':
                return <AddedCustomRowActionRootComponent action={selectedRowAction}
                    selectedTemplateName={this.props.selectedTemplateName} />
        }
    }

}

export const CQGridontrolConfigurationRootComponent = observer(
    CQGridControlConfiguration
);